import * as THREE from "three";

export const BASE_PLANE_Z = 0;

export function getCameraTargetOnZPlane(
  camera: THREE.Camera,
  z: number,
): THREE.Vector3 | null {
  const direction = camera.getWorldDirection(new THREE.Vector3());
  if (Math.abs(direction.z) < 1e-5) return null;

  const distance = (z - camera.position.z) / direction.z;
  if (!Number.isFinite(distance) || distance <= 0) return null;

  return camera.position.clone().add(direction.multiplyScalar(distance));
}

export function getSynchronizedBasePlaneOrbitTarget(
  camera: THREE.Camera,
  fallback: THREE.Vector3,
): THREE.Vector3 {
  const basePlaneTarget = getCameraTargetOnZPlane(camera, BASE_PLANE_Z);
  return basePlaneTarget && isFiniteVector3(basePlaneTarget)
    ? basePlaneTarget
    : fallback.clone();
}

function isFiniteVector3(vector: THREE.Vector3): boolean {
  return (
    Number.isFinite(vector.x) &&
    Number.isFinite(vector.y) &&
    Number.isFinite(vector.z)
  );
}
